import { useCallback } from 'react';
import { useFiltersContext } from '../contexts/filtersContext';
import { useSavedFilterContext } from '../contexts/savedFiltersContext';

export const useSavedFilterCreate = ({ onComplete }: { onComplete: () => void }) => {
  const { savedFilters } = useSavedFilterContext();
  const { filterInputs } = useFiltersContext();

  const onSave = useCallback(
    ({ title, includeColumns }: { title: string; includeColumns: boolean }) => {
      if (!title) {
        return;
      }
      onComplete();
      savedFilters.createSavedFilter({ name: title, filters: filterInputs, includeColumns });
    },
    [onComplete, savedFilters, filterInputs]
  );
  return { onSave };
};

export const useSavedOrgFilterCreate = ({ onComplete }: { onComplete: () => void }) => {
  const { savedFilters } = useSavedFilterContext();
  const { filterInputs } = useFiltersContext();

  const onSave = useCallback(
    ({ title, includeColumns }: { title: string; includeColumns: boolean }) => {
      if (!title) {
        return;
      }
      onComplete();
      savedFilters.createOrgSavedFilter({ name: title, filters: filterInputs, includeColumns });
    },
    [onComplete, savedFilters, filterInputs]
  );
  return { onSave };
};
